import { render, staticRenderFns } from "./Fenxiang.vue?vue&type=template&id=36ac6cb1&scoped=true"
import script from "./Fenxiang.vue?vue&type=script&lang=js"
export * from "./Fenxiang.vue?vue&type=script&lang=js"
import style0 from "./Fenxiang.vue?vue&type=style&index=0&id=36ac6cb1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ac6cb1",
  null
  
)

export default component.exports